<template>
  <div style="max-width: 350px">
    <div v-if="mode === 'DESIGN'">
      <div class="choice-item" style="margin-left: 6px" disabled>+</div>
    </div>
    <div v-else style="margin-left: 6px">
      <div v-if="!_value.length>0" class="choice-item" @click="$refs.orgPicker.show()">+</div>
      <div style="margin-top: 5px;" class="justify-between">
        <div v-for="(user, i) in _value" :key="i+'user'" style="flex: 0 0 16%;">
          <div v-if="_value.length>0 && i<12"  style="text-align: center; margin-right: auto; ">
            <div class="choice-item" style="background-color: #409EFF;border: none;margin: auto" @click="$refs.orgPicker.show('second')"></div>
            <div class="choice-item-name">{{user.name}}</div>
          </div>
        </div>
          <div v-if="_value.length>12" class="omit" @click="$refs.orgPicker.show('second')" style="height: 12px;">
            <span>.</span><span style="margin: 0 3px">.</span><span>.</span>
        </div>
        <div v-for="(user, i) in 10" :key="i" style="flex: 0 0 16%;"></div>
      </div>
      <dynamic-picker type="user" :multiple="multiple" ref="orgPicker" :selected="_value" @ok="selected"></dynamic-picker>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../../ComponentMinxins'
import dynamicPicker from "@/components/common/DynamicPicker";

export default {
  mixins: [componentMinxins],
  name: "DeptPicker",
  components: {dynamicPicker},
  props: {
    value:{
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择部门'
    },
    multiple:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showOrgSelect: false
    }
  },
  methods: {
    selected(values){
      this.showOrgSelect = false
      this._value = values
    },
    delDept(i){
      this._value.splice(i, 1)
    }
  }
}
</script>

<style scoped>
.placeholder{
  margin-left: 10px;
  color: #adabab;
  font-size: smaller;
}
.choice-item{
  width: 37px;
  height: 37px;
  line-height: 37px;
  text-align: center;
  border: 1px dashed #CDD0D6;
  border-radius: 5px;
  color: #909399;
}
.choice-item-name{
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  font-size: 14px;
  width: 48px;
  color: #909399;
  text-align: center;
  height: 28px;
  line-height: 28px;
}
.omit{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #909399;
  width: 100%;
  margin-top: -6px;
}
.justify-between{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between
}
</style>
